module.exports = __webpack_public_path__ + "img/34_21.f4fad24d.png";